
import { Component, OnInit , ViewChild} from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';
import { UserService } from '../../../../shared/user.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-vender-grid',
  templateUrl: './vender-grid.component.html',
  styleUrls: ['./vender-grid.component.css']
})
export class VenderGridComponent implements OnInit {
  title="Assistant Details";
  dtOptions: any = {};
  empList :any =[];
  mode :any;
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  constructor(public service : UserService) { }

  ngOnInit(): void {
        $(document).ready(function(){
  $('[data-toggle="tooltip"]').tooltip();
});
    this.empList = this.service.empList;
    //
    this.dtOptions = {
      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          className: 'btn btn-radius',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', className: 'btn btn-radius' }
      ],
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.columns().every(function () {
        const that = this;
        $('input', this.footer()).on('keyup change', function () {
          if (that.search() !== this['value']) {
            that
              .search(this['value'])
              .draw();
          }
        });
      });
    });
  }

        deletes()
 {
    Swal.fire({
      position: 'top-end',
      title: 'Do You Want To Delete',
      text: 'If Deleted, Data can not be reverted back!',
      icon: 'warning' ,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        Swal.fire(
            'Data Record Deleted Successfully..'

        )
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          'Changes will be Discarded..'
        )
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/Manage/vender/vender-grid/vender-grid.component.ts